<template>
  <ul>
    <!-- <li>
      <a href="https://www.facebook.com/3-Oaks-Gaming-108423585065971" target="_blank" rel="nofollow noopener noreferrer">
        Facebook
      </a>
    </li> -->
    <li>
      <a href="https://www.linkedin.com/company/kendooplay/?viewAsMember=true" target="_blank" rel="nofollow noopener noreferrer">
        LinkedIn
      </a>
    </li>
  </ul>
</template>


<script>
export default {
    name: "SocialLinks"
}
</script>
